// extracted by mini-css-extract-plugin
export default {"root":"dFom9LbWApui2ddgCsGc","block":"D7KaPXXaUKsNZ5spVvnL","placeHolderShimmer":"zK62gPhuKQgVxFlrFXIg"};